import React from 'react'

import { Formik } from 'formik'

import { Form, Button, Modal } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as FormGroups from './formGroups'

import * as EstructuraBalanceService from 'services/estructuraBalance.service'

const NuevaEstructuraBalanceModal = ({ show, handleClose, idNodoSeleccionado, refreshTreeView, editarData = null }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      idNodoSeleccionado: idNodoSeleccionado,
      correlativo: editarData ? editarData.correlativo : '',
      descripcion: editarData ? editarData.descripcion : '',
      generarCorrelativoFlag: false
    }),
    [idNodoSeleccionado, editarData]
  )

  const clickCrearEstructura = async data => {
    if (editarData) {
      EstructuraBalanceService.editarEstructura(data)
        .then(() => {
          __zariContext.snack('success', 'La estructura se ha actualizado.')
          refreshTreeView()
          handleClose()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      EstructuraBalanceService.nuevaEstructura(data)
        .then(() => {
          __zariContext.snack('success', 'La estructura se ha creado.')
          refreshTreeView()
          handleClose()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }

  return (
    <Modal show={show} size='md'>
      <Modal.Header>
        <Modal.Title>{!editarData ? 'NUEVO ESTRUCTURA BALANCE' : 'EDITAR ESTRUCTURA BALANCE'}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={clickCrearEstructura}>
        {({ handleSubmit, values, setFieldValue, handleChange, errors, touched, isSubmitting }) => (
          <Form>
            <Modal.Body>
              <FormGroups.CorrelativoFormGroup
                iError={errors.correlativo}
                iTouched={touched.correlativo}
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
                values={values}
                handleChange={handleChange}
              />
              <FormGroups.DescripcionFormGroup />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevaEstructuraBalanceModal
